export default __webpack_public_path__ + "static/media/twitterTheme-boy.e37a4bcd.svg";